import React, { useEffect, useState } from "react"
import Modal from "react-bootstrap/Modal"
import {
  getPatientDetail
} from "../../../core/services/api"
import "./ViewPatient.scss"
import { calculateAge } from "core/utils/date"
function ViewPatient({ closePrintModal, id }: any) {
  // const { id } = props
  console.log("close", closePrintModal)
  const [show, setShow] = useState(true)
  const [data, setData] = useState<any>()
  console.log("props,", id)
  const handleClose = () => {
    setShow(false)
    closePrintModal(false)
  }
  useEffect(() => {
    console.log("inside use effect", id)
    getPatientDetail(id)
      .then((res) => {
        console.log("res", res)
        setData(res)
      })
      .catch((err) => {
        console.log("error", err)
      })
  }, [])
  return (
    <div>
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Patient Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="patient-details-container">
            <div className="row row-section">
              <div className="col-4 key-container">Patient Name:</div>
              <div className="col-3 value-container">{data?.isVIP ? data?.mocId : data?.name}</div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">Age:</div>
              <div className="col-3 value-container">{calculateAge(data?.dob)}</div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">Email:</div>
              <div className="col-3 value-container">{data?.email}</div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">Gender:</div>
              <div className="col-3 value-container">{data?.gender}</div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">DOB:</div>
              <div className="col-3 value-container">{data?.dob}</div>
            </div>

            <div className="row row-section">
              <div className="col-4 key-container">Phone Number:</div>
              <div className="col-3 value-container">{data?.phoneNumber}</div>
            </div>

            <div className="row row-section">
              <div className="col-4 key-container">MaritalStatus:</div>
              <div className="col-3 value-container">{data?.maritalStatus}</div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">ReferredBy:</div>
              <div className="col-3 value-container">{data?.referredBy}</div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">
                Primary Consultant Name:
              </div>
              <div className="col-3 value-container">
                {data?.primaryConsultantName}
              </div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">Alternate PhoneNumber:</div>
              <div className="col-3 value-container">
                {data?.alternatePhoneNumber}
              </div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">Blood Group:</div>
              <div className="col-3 value-container">{data?.bloodGroup}</div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">
                Responsible person name:
              </div>
              <div className="col-3 value-container">
                {data?.responsiblePersonName}
              </div>
            </div>
            <div className="row row-section">
              <div className="col-4 key-container">
                Responsible person phoneNumber:
              </div>
              <div className="col-3 value-container">
                {data?.responsiblePersonPhoneNumber}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ViewPatient
